import React, { PropsWithChildren } from "react";

import { css, cx } from "@emotion/css";
import MuiCardActions from "@mui/material/CardActions";
import { QueryAwait } from "@steto-care/steto-query";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";
import { HandledErrorCard } from "@/uiKit/organisms/HandledErrorCard.tsx";

export type BaseCardFooterProps = PropsWithChildren<{}>;

export type CardFooterProps = AtomProps<BaseCardFooterProps>;

export const CardFooter: React.FC<CardFooterProps> = ({ children, className, ...props }) => {
  const styles = useStyles(makeStyles);

  return (
    <MuiCardActions
      className={cx(
        {
          [styles.root]: true,
          [styles.rootWithChildren]: !!children,
        },
        className,
      )}
      {...props}
    >
      <QueryAwait errorFallback={HandledErrorCard} pendingFallback={() => null}>
        {children}
      </QueryAwait>
    </MuiCardActions>
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(0, 12, 8, 12),
    gap: theme.spacing(16),
    width: "100%",
  }),
  rootWithChildren: css({
    padding: theme.spacing(8, 12, 8, 12),
  }),
});
